import { Component, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { getApp } from "../app";
import { Subject } from "rxjs";

@Component({
    selector: "app-next",
    templateUrl: "./next.component.html",
    styleUrls: ["./next.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NextComponent {
  app = getApp(app => {
    this.app = app;
  });
  @Input() current = "";
  @Input() array: string[] = [];
  @Output() navigate = new Subject<string>();

  constructor() {}
}
